<div class="input-search body-2 flex">
  <mat-icon>search</mat-icon>
  <input #inputEl class="grow" [(ngModel)]="value" matInput [placeholder]="resolvedPlaceholder()" autocomplete="off"/>
  @if (value()) {
    <mat-icon class="link-on-warning" (click)="value.set('')">close</mat-icon>
  } @else {
    <div class="no-close"></div>
  }
  @if (canCreate()) {
    <mat-icon class="link-active" (click)="createAction.emit()">add</mat-icon>
  }
</div>
